import baseAPI from '@/api/base';
import {
  EditMinyanimType,
  GetMinyanimType,
  RegisterMinyanimType,
} from '@/dtos/minyanim_type.dto';
import {
  DELETE_MINYANIM_TYPE_URL,
  EDIT_MINYANIM_TYPE_URL,
  GET_MINYANIM_TYPE_URL,
  REGISTER_MINYANIM_TYPE_URL,
  TOGGLE_MINYANIM_TYPE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class MinyanimType {
  static getMinyanimTypes = async (
    getMinyanimType: GetMinyanimType
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_MINYANIM_TYPE_URL, {
      params: getMinyanimType,
    });
    console.log('response', response);
    return response;
  };

  static registerMinyanimType = async (
    registerMinyanimType: RegisterMinyanimType
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_MINYANIM_TYPE_URL,
      {
        ...registerMinyanimType,
      }
    );
    console.log('response', response);
    return response;
  };

  static editMinyanimType = async (
    editMinyanimType: EditMinyanimType
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_MINYANIM_TYPE_URL,
      {
        ...editMinyanimType,
      }
    );
    return response;
  };

  static toggleMinyanimTypeIsActive = async (
    editMinyanimType: EditMinyanimType
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_MINYANIM_TYPE_IS_ACTIVE_URL,
      {
        ...editMinyanimType,
      }
    );
    return response;
  };

  static deleteMinyanimType = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_MINYANIM_TYPE_URL}/${id}`
    );
    return response;
  };
}

export default MinyanimType;
